import React from 'react';
import { Stack, Typography, Button, Chip } from '@mui/material';
// Open-link facts on the review screen: who filled it, who the owner is, the owner's banking, and the two resend actions.
export default function OpenLinkPanel({ app, api, onDone, onError }) {
  if (!app.agentCodeId) return null;
  const ob = app.ownerBanking || {}; const run = (fn, msg) => async () => { try { await fn(); onDone(msg); } catch (e) { onError(e.message); } };
  const banking = ob.status === 'complete' ? `Banking: completed by owner ${app.owner ? `${app.owner.name}, ${app.owner.email}` : ''}, ${new Date(ob.completedAt).toLocaleString()}`
    : ob.status === 'pending' ? 'Banking: waiting for owner' : 'Banking: entered by the owner in the application';
  return (<Stack spacing={1}>
    <Typography variant="subtitle2">Open link</Typography>
    <Typography variant="body2">Filled by {app.filler ? `${app.filler.name} (${app.filler.email})` : '—'}{app.filler && app.filler.isOwner === false && app.owner ? ` · owner ${app.owner.name || '—'} (${app.owner.email || 'no email yet'})` : ''}</Typography>
    <Stack direction="row" spacing={1} alignItems="center" sx={{ flexWrap: 'wrap' }}>
      <Chip size="small" color={ob.status === 'pending' ? 'warning' : 'success'} label={banking} />
      {ob.status === 'pending' && <Button size="small" onClick={run(() => api.ownerLink(app.id), 'Owner link sent')}>Resend owner link</Button>}
      <Button size="small" onClick={run(() => api.continueLink(app.id), 'Continue link sent')}>Resend continue link</Button>
    </Stack>
  </Stack>);
}
